import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose';

import getInitialValues from './getInitialValues';
import withNotifications from '../../../../common/withNotifications';
import withOwnerTypeAndId from '../../../../common/hoc/withOwnerTypeAndId';
import { getUserUrlPrefix } from '../../../../auth/selectors';
import {
  fetchPoVendor,
  updatePoVendor,
} from '../store/actions';
import { getPoVendor } from '../store/selectors';
import withLoading from '../../../../common/withLoading';
import { canUserModifyProducts } from '../../../../common/helpers/users';

const EditVendorFormContainer = compose(
  withOwnerTypeAndId,
  withRouter,
  connect(
    (state, props) => {
      const vendor = getPoVendor(state, props.params.id);
      return {
        canEditProducts: canUserModifyProducts(state.auth.permissions),
        vendor,
        showLoading: !vendor,
        baseUrl: `${getUserUrlPrefix(state)}/products/purchase-orders/vendors`,
      };
    }, {
      fetchPoVendor,
      updatePoVendor,
    }
  ),
  lifecycle({
    componentDidMount() {
      if (!this.props.vendor) {
        this.props.fetchPoVendor(this.props.ownerId, this.props.params.id);
      }
    },
  }),
  withLoading,
  withNotifications,
  withState('busy', 'setBusy', false),
  withProps(props => ({
    initialValues: getInitialValues(props.vendor),
    heading: 'Edit vendor',
  })),
  withHandlers({
    submitPoVendor: props => (values) => {
      props.setBusy(true);
      return props.updatePoVendor(props.ownerId, values)
        .then(() => {
          props.setBusy(false);
          props.router.push(props.baseUrl);
          props.addNotification({
            title: 'Success',
            level: 'success',
            message: 'Vendor successfully saved.',
          });
        })
        .catch(() => {
          props.setBusy(false);
        });
    },
  }),
);

export default EditVendorFormContainer;
